/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import HeaderComponent from 'components/HeaderComponent';
import styled from 'styled-components';
import { Creators as UserCreators } from 'store/ducks/user';
import {
  Card,
  CardHeader,
  CardContent,
  Box,
  Paper,
  Tooltip as ToltipMaterial,
  CircularProgress,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { useDispatch } from 'react-redux';
import StatusSwitch from 'components/StatusSwitch';
import Logo from 'images/logo_black.png';
import IconButton from '@material-ui/core/IconButton';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import moment from 'moment';
import { appColors } from 'utils/appColors';
import DefaultTable from 'components/Tables/DefaultTable';
import ChildrenImage from 'components/Pages/ClientPage/ChildrenImage';
import { push } from 'connected-react-router';

const StyledBoxImg = styled('img')`
  && {
    max-height: 120px;
    max-width: 120px;
  }
`;

const ModalContainer = styled(Paper)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    @media (max-width: 968px) {
      width: 70%;
    }
    @media (max-width: 768px) {
      width: 90%;
    }
    padding: 30px;
  }
`;

const translateDate = date => {
  return moment(date).format('DD/MM/YYYY') !== 'Invalid date'
    ? moment(date).format('DD/MM/YYYY')
    : 'Não preenchida';
};

const columnsActivities = () => [
  {
    title: 'Referência',
    field: 'id',
  },
  {
    title: 'Atividade',
    field: 'activity.name',
  },
  {
    title: 'Módulo',
    field: 'activity.module.name',
  },
  {
    title: 'Realizado em',
    field: 'created_at',
    render: rowData => translateDate(rowData.created_at),
  },
];

const ClientView = ({
  userInfo,
  ActivitiesDone,
  setFilters,
  totalReport,
  ReportChild,
  totalReportChild,
  loadingReportChild,
}) => {
  const dispatch = useDispatch();

  const genreMask = genre => {
    return genre === 'F' ? 'Feminino' : 'Masculino';
  };

  const AgeChild = age => {
    const a = moment();
    const b = moment(age);
    const idade = a.diff(b, 'years');
    return `${idade} anos`;
  };

  const [openModal, setOpenModal] = React.useState(false);
  const [filtersChild, setFiltersChild] = React.useState({
    childId: null,
    childName: '',
    search: '',
    orderByColumn: 'name',
    orderByDirection: 'asc',
    page: 1,
    perPage: 10,
  });

  const handleModalClose = () => {
    setOpenModal(false);
    setFiltersChild(oldState => ({
      ...oldState,
      page: 1,
      perPage: 10,
    }));
  };

  React.useEffect(() => {
    if (filtersChild.childId)
      dispatch(UserCreators.getReportChildRequest(filtersChild));
  }, [filtersChild]);

  React.useEffect(() => {
    if (!loadingReportChild && ReportChild.length > 0) {
      console.tron.log(ReportChild);
    }
  }, [ReportChild]);

  const handleOpenModal = (childId, childName) => {
    setFiltersChild(oldState => ({
      ...oldState,
      childId: [{ id: childId }],
      childName,
    }));
    setOpenModal(true);
  };

  const ChildrenLink = ({ rowData }) => {
    return (
      <Button
        onClick={() => handleOpenModal(rowData.id, rowData.name)}
        style={{ color: '#045091' }}
      >
        {rowData.name}
      </Button>
    );
  };

  const columns = ({ changeStatus }) => [
    {
      title: 'Referência',
      field: 'id',
    },
    {
      title: 'Imagem',
      field: 'images',
      render: rowData => <ChildrenImage rowData={rowData} />,
    },
    {
      title: 'Nome',
      field: 'name',
      render: rowData => <ChildrenLink rowData={rowData} />,
    },
    {
      title: 'Gênero',
      field: 'genre',
      render: rowData => genreMask(rowData.genre),
    },
    {
      title: 'Status',
      render: rowData => (
        <StatusSwitch
          changeStatus={changeStatus}
          rowData={rowData}
          item={rowData.status}
        />
      ),
    },
    {
      title: 'Idade',
      field: 'genre',
      render: rowData => AgeChild(rowData.birth_date),
    },
    {
      title: 'Data de Nascimento',
      field: 'birth_date',
      cellStyle: {
        textAlign: 'center',
      },
      render: rowData => translateDate(rowData.birth_date),
    },
  ];

  const [localState, setLocalState] = React.useState({
    search: '',
    orderByColumn: 'name',
    orderByDirection: 'asc',
    page: 1,
    perPage: 10,
  });

  React.useEffect(() => {
    setFilters(localState);
  }, [localState]);
  const [setDeleteState] = React.useState({
    open: false,
    item: {},
  });

  const onDeleteRequest = item => {
    setDeleteState({ open: true, item });
  };

  const translateGenre = genre => {
    return genre === 'M' ? 'Masculino' : 'Feminino';
  };

  const getFunction = data => {
    setLocalState(oldLocalState => ({ ...oldLocalState, ...data }));
  };

  const getFunctionChildModal = data => {
    setFiltersChild(oldLocalState => ({ ...oldLocalState, ...data }));
  };

  const handleBack = () => {
    dispatch(push(`/clients`));
  };

  const Print = (data, ReportChild) => {
    // const divToPrint = document.getElementsByClassName('toPrint')[0].outerHTML;

    const newWindow = window.open('', 'Relatório', 'width=800, height=500');
    const document = newWindow.document.open();

    let InnerHtml = `
      <div 
          style="display: flex;
          justify-content: space-evenly;
          align-items: center;
          margin: 20px 0px">
          <img 
            src="${
  data.images.original !== ''
    ? data.images.original
    : 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png'
}"
            alt="responsável"
            height="175"
            width="175"
          />
        <div>
          <p><span style="font-weight: bold; color: #2aabe2">Responsável: </span>${
  data.name
}</p>      
          <p><span style="font-weight: bold; color: #2aabe2">Gênero: </span>${
  data.genre === 'F' ? 'Feminino' : 'Masculino'
}</p>      
          <p><span style="font-weight: bold; color: #2aabe2">Email: </span>${
  data.email
}</p>      
          <p><span style="font-weight: bold; color: #2aabe2">Grupo: </span>${
  data.group.name
}</p>      
          <p><span style="font-weight: bold; color: #2aabe2">Telefone: </span>${
  data.cell_phone
}</p>      
        </div>
      </div>
      <h2 style="margin-top: 40px">Filhos (a) de ${data.name}</h2></br>
      <table style="width:100%; border: none;">
          <tr>
            <th>Referência</th>
            <th>Imagem</th>
            <th>Nome</th>
            <th>Gênero</th>
            <th>Status</th>
            <th>Idade</th>
            <th>Data de Nascimento</th>
          </tr>
    `;

    data.user_children.map(item => {
      InnerHtml += `        
          <tr>
            <td>${item.id}</td>
            <td><img
            src="${
  item.images.original !== ''
    ? item.images.original
    : 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png'
}"
            alt="responsável"
            height="70"
            width="70"
          /></td>
            <td style="white-space: wrap; max-width: 100px">${item.name}</td>
            <td>${item.genre === 'F' ? 'Feminino' : 'Masculino'}</td>
            <td>${item.status === 1 ? 'Ativo' : 'Desativado'}</td>
            <td>${AgeChild(item.birth_date)}</td>
            <td>${translateDate(item.birth_date)}</td>
          </tr>    
        `;
    });

    InnerHtml += `</table>`;

    // salva o id do primeiro child
    let firstIdChild = ReportChild[0]?.child?.id;

    InnerHtml += `<h3 style="margin-top: 40px">Lista de Atividades de ${ReportChild[0]?.child.name}</h3></br>`;
    InnerHtml += ` 
        <table style="width:100%; border: none;">
        <tr>
          <th>Referência</th>
          <th>Atividade</th>
          <th>Data</th>
        </tr>
        <tr>
          <td>${ReportChild[0]?.id}</td>
          <td>${ReportChild[0]?.activity.name}</td>
          <td>${translateDate(ReportChild[0]?.created_at)}</td>
        </tr>  
    `;

    ReportChild.slice(1).map(item => {
      if (item.child.id !== firstIdChild) {
        InnerHtml += `</table></div>  `;

        InnerHtml += `<h3 style="margin-top: 40px">Lista de Atividades de ${item.child.name}</h3></br>`;

        InnerHtml += ` 
        <table style="width:100%; border: none;">
        <tr>
          <th>Referência</th>
          <th>Atividade</th>
          <th>Data</th>
        </tr>
        <tr>
          <td>${ReportChild[0]?.id}</td>
          <td>${ReportChild[0]?.activity.name}</td>
          <td>${translateDate(ReportChild[0]?.created_at)}</td>
        </tr>  
        `;

        // troco o valor de firstIdChild para comparar no proximo laço
        firstIdChild = item.child.id;
      } else {
        InnerHtml += `
            <tr>
              <td>${item.id}</td>
              <td>${item.activity.name}</td>
              <td>${translateDate(item.created_at)}</td>
            </tr>   
        `;
      }
    });

    const pageContent = `${'<!DOCTYPE html>' +
      '<html>' +
      '<head>' +
      '<meta charset="utf-8" />' +
      '</head>' +
      `<style>
      table {
        font-family: Roboto, sans-serif;
        border: none;
        width: 100%;
      }
      
      td, th {
        border: none;
        text-align: center;
        padding: 5px 0px;
      }
      
      tr:nth-child(even) {
        background-color: rgba(70, 130, 180, 0.1);
      }
      </style>` +
      '<body>'}
        <div style="display: flex; justify-content: center;">   
          <img
           src="${Logo}"
           alt="logo"
           height="80"
           width="80"
         />
         </div>
         <div style="border-top: 2px solid #2aabe2;
          background-color: #cecece;
          margin-top: 15px;
          padding: 5px;
          font-size: 17px;
          text-align: center;">
           Dados do Responsável
         </div>
         ${InnerHtml}
       </body>
     </html>`;
    try {
      document.write(pageContent);
      document.close();
      newWindow.print();
      // newWindow.close();
    } catch (error) {
      console.tron.log('err');
    }
  };

  const [clickToPrint, setClickToPrint] = React.useState(false);
  React.useEffect(() => {
    if (clickToPrint && !loadingReportChild && ReportChild.length > 0) {
      Print(userInfo, ReportChild);
      setTimeout(() => {
        setClickToPrint(false);
      }, 2000);
    }
  }, [ReportChild]);
  const handlePrint = data => {
    setClickToPrint(true);

    const idsChildren = data?.user_children.map(item => ({
      id: item.id,
    }));

    setFiltersChild(oldState => ({
      ...oldState,
      childId: idsChildren,
    }));
  };

  const changeStatus = (e, id, rowData) => {
    const newStatus = e.target.checked;
    const data = {
      itemId: id,
      status: newStatus ? 1 : 0,
      name: 'module',
    };
    console.log(data);
    console.log(rowData);
    console.tron.log(data);
    // dispatch(GlobalsStyleCreators.getRequest(data));
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        <HeaderComponent goBack={handleBack} />
        <div style={{ position: 'absolute', right: 0 }}>
          <ToltipMaterial title="Gerar Pdf">
            <IconButton onClick={() => handlePrint(userInfo)} aria-label="pdf">
              <CloudDownloadIcon style={{ width: 40, height: 40 }} />
            </IconButton>
          </ToltipMaterial>
        </div>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          flexWrap="wrap"
          alignItems="stretch"
          marginLeft={-1}
          marginRight={-1}
        >
          <Box flexGrow={1} p={1}>
            <Card
              style={{ display: 'flex', flexDirection: 'row', height: '100%' }}
            >
              <CardHeader title="Dados do responsável" />
              <CardContent
                style={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                }}
              >
                {userInfo.images.original !== '' && (
                  <StyledBoxImg src={userInfo.images.original} />
                )}
                {userInfo.images.original === '' && (
                  <StyledBoxImg src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Circle-icons-profile.svg/1024px-Circle-icons-profile.svg.png" />
                )}
              </CardContent>
              <CardContent
                style={{ lineHeight: 2.0, color: '#4e3e51', marginLeft: -10 }}
              >
                <span style={{ color: appColors.primary, fontWeight: '500' }}>
                  Responsável:
                </span>{' '}
                {userInfo.name} <br />
                <span style={{ color: appColors.primary, fontWeight: '500' }}>
                  Gênero:
                </span>{' '}
                {translateGenre(userInfo.genre)} <br />
                <span style={{ color: appColors.primary, fontWeight: '500' }}>
                  Email:
                </span>{' '}
                {userInfo.email} <br />
                <span style={{ color: appColors.primary, fontWeight: '500' }}>
                  Grupo:
                </span>{' '}
                {userInfo.group.name} <br />
                <span style={{ color: appColors.primary, fontWeight: '500' }}>
                  Telefone principal:
                </span>{' '}
                {userInfo.cell_phone}
                <br />
              </CardContent>
            </Card>
          </Box>
        </Box>
      </div>
      <div>
        <BoxTable
          userInfo={userInfo}
          getFunction={getFunction}
          changeStatus={changeStatus}
          localState={localState}
          title={`Filhos de ${userInfo.name}`}
          columns={columns}
        />
        <BoxTable
          userInfo={ActivitiesDone}
          getFunction={getFunction}
          changeStatus={changeStatus}
          localState={localState}
          title={`Atividades Realizadas por ${userInfo.name}`}
          columnsActivities={columnsActivities}
          totalReport={totalReport}
        />
      </div>
      <Modal open={openModal} onClose={handleModalClose}>
        <ModalContainer>
          {loadingReportChild ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={50} />
            </div>
          ) : (
            <BoxTable
              userInfo={ReportChild}
              getFunction={getFunctionChildModal}
              changeStatus={changeStatus}
              localState={filtersChild}
              title={`Atividades Realizadas por ${filtersChild.childName}`}
              columnsActivities={columnsActivities}
              totalReport={totalReportChild}
            />
          )}
        </ModalContainer>
      </Modal>
    </>
  );
};

const BoxTable = ({
  userInfo,
  getFunction,
  changeStatus,
  localState,
  title,
  columnsActivities,
  columns,
  totalReport,
}) => (
  <Box
    display="flex"
    flexDirection="row"
    justifyContent="center"
    flexWrap="wrap"
    alignItems="stretch"
    marginLeft={-1}
    marginRight={-1}
  >
    <Box flexGrow={1} p={1}>
      <Card style={{ height: '100%' }}>
        <CardHeader title={title} />
        <div className="toPrint">
          <Paper>
            {columnsActivities ? (
              <DefaultTable
                getFunction={getFunction}
                columns={columnsActivities({
                  userInfo,
                  changeStatus,
                })}
                data={userInfo && userInfo}
                total={totalReport}
                isLoading={false}
                page={localState?.page}
                perPage={localState?.perPage}
                showLegend={false}
                sorting={false}
              />
            ) : (
              <DefaultTable
                getFunction={getFunction}
                columns={columns({
                  userInfo,
                  changeStatus,
                })}
                data={userInfo.user_children ? userInfo.user_children : []}
                total={userInfo?.user_children?.length}
                isLoading={false}
                page={localState?.page}
                perPage={localState?.perPage}
                showLegend={false}
                sorting={false}
                disablePagination
              />
            )}
          </Paper>
        </div>
      </Card>
    </Box>
  </Box>
);

ClientView.propTypes = {
  userInfo: PropTypes.oneOfType([PropTypes.object]).isRequired,
  ActivitiesDone: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default ClientView;
